/**
 * Where a contract came from - three words only (owner, 5 Oct 2026: "كان بوكينج ( ليه رقم حجز ) ولا عميل فرع walk in",
 * then "عايز بوكينج او بوكينج ستاف او واك ان بس"): no booking number on Ejar = "Walk-in"; a booking staff made on Ejar
 * ("System") = "Booking · staff"; any other booking (the app, the website, one not read yet) = "Booking". The engine's
 * daily report e-mail uses the same rule (engine/api/daily_email.py source_of).
 */
export const contractSourceOf = (doc) => {
    const number = String(doc.booking_number || doc['Booking Number'] || '').trim();
    if (!number) return 'Walk-in';
    return String(doc.booking_source || '').trim().toLowerCase() === 'system' ? 'Booking · staff' : 'Booking';
};
